import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/icons.module.scss'
import { User } from 'lucide-react'

export default function ProfileIcon({ contextStyles, hoverStyles = null, selectedStyles = null }) {
    return (
        <div className={cn(styles.iconComp, contextStyles, hoverStyles, selectedStyles)}>
            <User />
        </div>
    )
}
